import { ReviewsOpinionRecords } from 'features/reviews';

export const extractReviewsOpinion = (reviewsOpinions: ReviewsOpinionRecords[]) => (reviewId: string) => {
  return reviewsOpinions.find(({ reviewId: rId }) => rId === reviewId)?.opinion ?? null;
};

export function getRandomInteger(max: number) {
  const rand = Math.random() * (max + 1);
  return Math.floor(rand);
}
